module.exports = __webpack_public_path__ + "src/img/artist/name09.svg?5b2143b2b4378d480f1175fbd8cca1bd";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/name09.svg
// module id = 145
// module chunks = 0